module.exports = __webpack_public_path__ + "static/media/Socialresp.426a5136.jpg";